<div class="not-found-container">
  <div class="content {{ withSlope ? '' : 'without-slope' }}">
    <svg viewBox="0 0 200 30" class="slope">
      <path d="M 0,12 200,0 v 30 H 0 Z"></path>
    </svg>
    <div class="maincontainer">
      <div class="wrap">
        <div class="text">
          <h1>{{ headline }}</h1>
          <div class="description">
            {{ text }}
          </div>
          <a [customRouterLink]="link" class="goback" (click)="backToLink()">
            <img src="./assets/ui/shared/icons/go_back_icon.svg" alt="go_back" title="go_back">
            {{ backToHomeText }}
          </a>
        </div>
        <div class="imgcontainer">
          <img src="./assets/ui/shared/images/not_found_error_page.png" alt="not_found_image" title="not_found_image">
        </div>
      </div>
    </div>
  </div>
</div>
